import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)
import Offer from '../offer/app.vue'

document.addEventListener('turbolinks:load', () => {
  let element = document.getElementById('offer-ui')
  if (element != null) {
    var vueapp = new Vue({
      el: '#offer-ui',
      template: '<App/>',
      render: h => h(Offer, {
        props: {
          data: JSON.parse(element.dataset.data)
        }
      }),
    });
  }
});
